import { v as bvVar } from 'bv';
import { preConfigurations, afterConfigurations } from './config/base_config';

const buildScript = (resolve) => {
  const { host, apiKey } = bvVar('zendeskConfig');
  const scriptTag = document.createElement('script');

  scriptTag.id = 'ze-snippet';
  scriptTag.src = `${host}?key=${apiKey}`;
  scriptTag.async = 'async';
  scriptTag.defer = 'defer';
  scriptTag.onload = () => resolve();
  document.body.appendChild(scriptTag);
};

export default () => (
  new Promise((resolve) => {
    preConfigurations();
    buildScript(resolve);
  })
    .then(() => afterConfigurations())
);
